












































































































































































































































import { Vue, Component } from "vue-property-decorator";
import {
  ApplicantList,
  FetchPaginatedApplicantsPayload,
} from "@/modules/applicants/types";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import Clipboard from "clipboard";
import Loader from "@/modules/externals/components/Loader.vue";
import Paginate from "vuejs-paginate";
import EmptyTable from "./EmptyTable.vue";
import { FetchPayload } from "../types";
import TableHeader from "@/modules/externals/components/TableHeader.vue";
import TableLoader from "@/modules/externals/components/TableLoader.vue";

const Applicants = namespace("applicant");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const utc = require("dayjs/plugin/utc");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  components: {
    loader: Loader,
    paginate: Paginate,
    "empty-table": EmptyTable,
    "table-header": TableHeader,
    "table-loader": TableLoader,
  },
})
export default class AllApplicantsTable extends Vue {
  @Applicants.Getter("allApplicants") allApplicants: ApplicantList;
  @Applicants.Getter("isAllApplicantsEmpty") isAllApplicantsEmpty: boolean;
  @Applicants.Getter("sortOrder") sortOrder: string;
  @Applicants.Getter("sortBy") sortBy: string;
  @Applicants.Getter("isFetchingApplicants") isFetchingApplicants: boolean;
  @Applicants.Action("fetchPaginatedApplicants")
  fetchPaginatedApplicants!: (
    payload: FetchPaginatedApplicantsPayload
  ) => Promise<{}>;
  @Applicants.Action("fetchApplicants") fetchApplicants!: (
    payload: FetchPayload
  ) => Promise<{}>;
  @Applicants.Action("setSortOrder")
  setSortOrder!: (sortOrder: string) => void;
  @Applicants.Action("setSortBy")
  setSortBy!: (sortBy: string) => void;

  hasApplicantError = false;
  applicantError = "";
  loading = false;

  mounted() {
    const clipboard = new Clipboard("#clipboard", {
      target: function (trigger) {
        return trigger.nextElementSibling as Element;
      },
      text: function (trigger) {
        return trigger.getAttribute("data-clipboardtext") as string;
      },
    });

    clipboard.on("success", (event) => {
      console.log("Text", event.text);
    });
    clipboard.on("error", (event) => {
      console.log("Error Text", event.trigger);
    });
  }
  async sort(sortBy, sortOrder) {
    this.setSortOrder(sortOrder);
    this.setSortBy(sortBy);
    await this.fetchApplicants({
      status: "all",
    });
  }
  async changePage(pageNum: number) {
    this.loading = true;
    await this.fetchPaginatedApplicants({ pageIndex: pageNum, status: "all" });
    this.loading = false;
  }
  localDate(date: string) {
    return dayjs(date).format("MMM D YYYY");
  }
  localTime(date: string) {
    return dayjs(date).subtract(5, "hour").format("h:mm a");
  }
}
